import React from 'react';
import './index.scss';

export default function Index(props) {
  const {
    productIsExhibition,
    companyProfileUrl,
    homeUrl,
    companyVideoUrl,
    companyVideoPath,
    companyHasPassAssessment,
    trustPassProfileAssessmentUrl,
    i18n,
  } = props;
  return (
    <div className="cp-footer">
      <span className="footer-item first">
        <a
          className="link-default"
          href={`${
            productIsExhibition ? companyProfileUrl : homeUrl
          }?tracelog=product_detail_cp`}
          target="_blank"
          rel="nofollow"
        >
          {i18n['detailCompanyProfileFooter_link_website']}
        </a>
      </span>
      {companyVideoPath && (
        <span className="footer-item">
          <a
            className="link-default"
            href={companyVideoUrl}
            target="_blank"
            rel="nofollow"
            data-domdot="id:25861"
          >
            {i18n['detailCompanyProfileFooter_link_video']}
          </a>
        </span>
      )}
      {companyHasPassAssessment && (
        <span className="footer-item">
          <a
            className="link-default"
            href={`${trustPassProfileAssessmentUrl}?tracelog=product_detail_report`}
            target="_blank"
            rel="nofollow"
          >
            {i18n['detailCompanyProfileFooter_link_report']}
          </a>
        </span>
      )}
    </div>
  );
}
